import React, { useEffect } from "react";
import "./RenderSelect.css";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import { NavItem } from "react-bootstrap";
import { Typography } from "@mui/material";

const RenderSelectMch = (props) => {
  const {
    value,
    options,
    name,
    onChange,
    placeholder,
    title,
    defaultValue,
    disabled,
    requiredprop=false
  } = props;
  //  useEffect(() => {
  //    if (options && options.length > 0 && !value) {
  //      onChange(name, options.id);
  //    }
  //  }, [options, name, onChange, value]);
  return (
    <>
      {title && (
        <Typography className="title-text">
          {title}
          {requiredprop && <span className="required-field">*</span>}
        </Typography>
      )}

      <Select
        name={name}
        value={value}
        placeholder={placeholder}
        onChange={() => console.log("hello")}
        defaultValue={defaultValue}
        fullWidth
        size="small"
        disabled={disabled}
      >
        {options?.map((item) => {
          return (
            <MenuItem key={item.id} value={item.id}>
              {item.name}
            </MenuItem>
          );
        })}
      </Select>
    </>
  );
};

export default RenderSelectMch;
